// /jv/ Looks like this is config for locally served BE and FE.
export default {
  env: 'development',
  // apiUrl: 'http://localhost:8080',
  apiUrl: 'https://api.develop.referoo.co',
  sentryEnv: 'develop', // /jv/ can't use above 'env' because it looks like its used as part of build process however I could not find how or where it is used.
};
